import { isRegionCode } from "./url-prefix"
import { splitLocalePrefix } from "../i18n/routing"

/**
 * The region served without a path segment. tienda.nelo.mx is the Mexican store, so a
 * /mx in every URL only repeated the domain; any other region keeps its /<cc> prefix.
 */
export const DEFAULT_REGION = process.env.NEXT_PUBLIC_DEFAULT_REGION || "mx"

export interface RegionPath {
  /** The locale prefix, e.g. "/en", or "" for the default locale */
  prefix: string
  /** The region the URL resolves to */
  region: string
  /** Whether the URL names the region (/mx/…) instead of implying the default */
  explicit: boolean
  /** The path after the locale prefix and region, always starting with "/" */
  rest: string
}

/**
 * @param pathname - A browser or request pathname, e.g. /productos/airpods, /mx/productos/airpods or /en/studio
 */
export const splitRegion = (pathname: string): RegionPath => {
  const { prefix, rest } = splitLocalePrefix(pathname)
  const first = rest.split("/")[1] ?? ""

  if (isRegionCode(first)) return { prefix, region: first, explicit: true, rest: rest.slice(first.length + 1) || "/" }

  return { prefix, region: DEFAULT_REGION, explicit: false, rest }
}

/** The path segment a region is served under: none for the default region, /<cc> for any other. */
export const regionPrefix = (countryCode: string): string => (countryCode === DEFAULT_REGION ? "" : `/${countryCode}`)
